// Costume registry for the STANDALONE app. Maps an org's costume_id to its
// costume object. Standalone orgs have no host application, so every
// host-powered data button is forced off — except pastEnquiries, which is
// Jigyasa's own returning-lead detection.

import { COWORKING_COSTUME } from "./coworking";
import { REAL_ESTATE_COSTUME } from "./realEstate";
import { INTERIORS_COSTUME } from "./interiors";
import { CLINIC_COSTUME } from "./clinic";
import { SOFTWARE_COSTUME } from "./software";
import { OTHERS_COSTUME } from "./others";
import { AUMONLINE_COSTUME } from "./aumonline";

const STANDALONE_BUTTONS = {
  liveStock: false,
  upcomingStock: false,
  customerFootprint: false,
  pastEnquiries: true,
  pricingAndOffers: false,
  activityHistory: false,
  renewalPipeline: false,
  locationCatalog: false,
  satisfaction: false,
  availability: false,
  compliance: false,
  communications: false,
};

const COSTUMES = {
  coworking_v1: COWORKING_COSTUME,
  real_estate_v1: REAL_ESTATE_COSTUME,
  interiors_v1: INTERIORS_COSTUME,
  clinic_v1: CLINIC_COSTUME,
  software_v1: SOFTWARE_COSTUME,
  others_v1: OTHERS_COSTUME,
  aumonline_v1: AUMONLINE_COSTUME,
};

export const standaloneCostume = (costumeId) => {
  const base = COSTUMES[costumeId] || COWORKING_COSTUME;
  return { ...base, buttonsOn: { ...STANDALONE_BUTTONS } };
};

// Shown as pick-one cards during signup.
export const INDUSTRY_OPTIONS = [
  { id: "real_estate_v1", label: "Real estate", blurb: "Builders, agents & property consultants" },
  { id: "interiors_v1", label: "Interiors & architecture", blurb: "Design studios, architects & contractors" },
  { id: "clinic_v1", label: "Clinic", blurb: "Doctors, dental, skin, physio & diagnostics" },
  { id: "coworking_v1", label: "Coworking space", blurb: "Shared offices, hubs & business centres" },
  { id: "software_v1", label: "Software / IT products", blurb: "SaaS, software products & IT services" },
  { id: "others_v1", label: "Something else", blurb: "Any other business — works for everyone" },
];
